import React, { useState } from 'react';
import { X, Code2, ChevronDown, ChevronUp } from 'lucide-react';

const TechStackPopup = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end pointer-events-none">
            {/* Popup content */}
            <div
                className={`mb-3 transition-all duration-300 ease-in-out origin-bottom-right ${isOpen ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0 scale-95 pointer-events-none'
                    }`}
                style={{ width: '320px' }}
            >
                <div className="rounded-2xl overflow-hidden shadow-2xl bg-white border border-slate-200" style={{ boxShadow: '0 10px 40px -10px rgba(99,102,241,0.2)' }}>
                    {/* Header */}
                    <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100" style={{ background: 'linear-gradient(135deg, rgba(99,102,241,0.05), rgba(139,92,246,0.05))' }}>
                        <div className="flex items-center gap-2 font-bold text-slate-800 text-lg">
                            <Code2 size={20} className="text-indigo-500" />
                            <span>Tech Stack</span>
                        </div>
                        <button
                            onClick={() => setIsOpen(false)}
                            className="text-slate-400 hover:text-slate-600 transition-colors"
                        >
                            <X size={20} />
                        </button>
                    </div>

                    {/* Body */}
                    <div className="p-5 bg-white">
                        {/* Frontend Section */}
                        <div className="mb-5 relative">
                            {/* Decorative background element for frontend */}
                            <div
                                className="absolute -left-6 -top-4 w-24 h-24 rounded-full border border-indigo-500/20 opacity-40"
                                style={{ transform: 'rotate(-45deg)' }}
                            />
                            <div
                                className="absolute -left-2 top-0 w-20 h-20 rounded-full border border-violet-500/10 opacity-60"
                            />
                            <div className="relative z-10">
                                <p className="text-xs font-bold tracking-widest text-slate-400 mb-1">FRONTEND</p>
                                <h3 className="text-slate-800 text-xl font-bold mb-1">React.js</h3>
                                <p className="text-slate-500 text-sm">(with React Query)</p>
                            </div>
                        </div>

                        {/* Divider text with styling line */}
                        <div className="h-px w-full bg-slate-100 mb-5 relative">
                            <div className="absolute right-10 top-1/2 -translate-y-1/2 w-4 h-8 border-l border-indigo-500/30 transform rotate-12" />
                        </div>

                        {/* Backend Section */}
                        <div className="mb-6 relative">
                            {/* Decorative background element for backend */}
                            <div
                                className="absolute -left-4 -top-2 w-16 h-12 rounded-lg border border-slate-200 opacity-50"
                            />
                            <div className="relative z-10">
                                <p className="text-xs font-bold tracking-widest text-slate-400 mb-1">BACKEND & DATABASE</p>
                                <h3 className="text-slate-800 text-xl font-bold">FastAPI & MongoDB</h3>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="text-center mt-2 pt-2 border-t border-slate-50">
                            <p className="text-slate-500 text-sm font-medium">
                                Built with <span className="text-indigo-500">💙</span> by SlashEasy
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Trigger Button */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-2.5 px-5 py-2.5 rounded-full font-bold text-white shadow-lg transition-transform hover:scale-105 active:scale-95 border border-white/20 pointer-events-auto"
                style={{
                    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                    boxShadow: '0 4px 20px rgba(99,102,241,0.3)'
                }}
            >
                <span className="relative flex h-3 w-3">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
                </span>
                <span className="text-sm">Built by SlashEasy</span>
                {isOpen ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
            </button>
        </div>
    );
};

export default TechStackPopup;
